<template>
  <div v-if="isPremium" class="body-1 d-inline-block">
    <v-icon color="yellow darken-2">mdi-crown-outline</v-icon>
    Você possui assinatura premium até {{ empresa.dataVencimentoContrato | date }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['empresa', 'isPremium']),
  },
};
</script>
